import React from 'react';
const Title = ({ text, value }: { text: React.ReactNode; value: React.ReactNode }) => (
    <div>
        <div>{text}</div>
        <div className="text-bold text-size-18">{value}</div>
    </div>
);

export default Title;
